import { CaseSizeRuleCreateRequestType } from "@sellar-io/api-v2/types";

import z from "zod";

export type CreatePackageRuleFormInputs = CaseSizeRuleCreateRequestType;

export type CreatePackageRuleFormValues = {
  containerType: CreatePackageRuleFormInputs["containerType"];
  unit: CreatePackageRuleFormInputs["unit"];
  volume?: number;
  quantity?: number;
};

export const defaultCaseSizeRuleFormValues = {
  containerType: "bottle",
  unit: "ml",
} as const satisfies Pick<
  CreatePackageRuleFormInputs,
  "containerType" | "unit"
>;

export const createPackageRuleFormSchema = z.object({
  containerType: z.enum(["bottle", "can"]),
  volume: z.number().min(1),
  unit: z.enum(["gal", "L", "ml", "cl", "pt", "oz", "g", "kg"]),
  quantity: z.number().int().min(1),
});

export const getCreatePackageRuleFormValues = (
  initialValues?: CreatePackageRuleFormInputs,
): CreatePackageRuleFormValues => ({
  containerType:
    initialValues?.containerType ?? defaultCaseSizeRuleFormValues.containerType,
  unit: initialValues?.unit ?? defaultCaseSizeRuleFormValues.unit,
  volume: initialValues?.volume,
  quantity: initialValues?.quantity,
});
